<template>
  <div>
    <b-modal
      id="modal-role"
      ref="my-modal"
      cancel-variant="outline-secondary"
      :title="$t('DEBTIA_ADD_PROCESS')"
      no-close-on-backdrop
      centered
      hide-footer
    >
      <b-overlay
        id="overlay-background"
        :show="loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <validation-observer ref="simpleRules">
          <b-form>
            <b-row>
              <b-col md="12">
                <b-form-group
                  label="Title"
                  label-for="title"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    rules="required"
                  >
                    <b-form-input
                      v-model="title"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Title"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                md="12"
              >
                <b-form-checkbox
                  v-model="secondaryProcessCheck"
                  class="custom-control-primary"
                >
                  Secondary Process
                </b-form-checkbox>
              </b-col>
              <b-col
                md="12"
                class="mb-1"
              >
                <b-form-checkbox
                  v-model="runOtherProcessCheck"
                  class="custom-control-primary"
                  :disabled="!secondaryProcessCheck"
                >
                  Pause other process(es) while running.
                </b-form-checkbox>
              </b-col>
              <b-col cols="12">
                <b-button
                  variant="primary"
                  type="submit"
                  class="addProcessBtn"
                  @click.prevent="validationForm"
                >
                  {{ $t('DEBTIA_SUBMIT') }}
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
// import vSelect from 'vue-select'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup,
  BFormInput,
  BButton,
  BForm,
  BRow,
  BCol,
  BOverlay,
  BFormCheckbox,
} from 'bootstrap-vue'
import { required } from '@validations'
import axios from '@axios'
// import constants from '@/app-configs/constants'

export default {
  components: {
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    BRow,
    BCol,
    ValidationProvider,
    ValidationObserver,
    // BCardCode,
    BOverlay,
    BFormCheckbox,
  },
  data() {
    return {
      title: '',
      required,
      loader: false,
      secondaryProcessCheck: false,
      runOtherProcessCheck: false,
    }
  },
  watch: {
    secondaryProcessCheck: {
      handler() {
        if (!this.secondaryProcessCheck) {
          this.runOtherProcessCheck = false
        }
      },
    },
  },
  created() {
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.loader = true
          const url = '/process/create'
          axios.post(url, {
            title: this.title,
            type: this.secondaryProcessCheck ? 'Secondary' : 'Primary',
            pause_other_process: this.runOtherProcessCheck,
          }).then(response => {
            if (response.status === 200) {
              // this.loader = false
              this.$router.push(`/process/view/${response.data.data.id}`)
            }
          }).catch(error => {
            console.log('error ', error)
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
  .addProcessBtn {
    width: 100%;
  }
</style>
